<template>
  <Table.Row v-for="n in skeletonCount" :key="n" :id="n.toString()">
    <Table.CheckboxCell class="hidden tablet-h:flex" />
    <Table.Cell>
      <div class="w-6 h-6 flex items-center justify-center mr-2.5">
        <Skeleton class="w-[17px] h-6" />
      </div>
      <div>
        <Skeleton class="w-[85px] h-[13px] mb-1" />
        <Skeleton class="tablet-h:hidden w-[150px] h-[13px]" />
      </div>
    </Table.Cell>
    <Table.Cell class="hidden tablet-h:flex">
      <Skeleton class="w-[85px] h-[13px]" />
    </Table.Cell>
    <Table.Cell class="hidden tablet-h:flex">
      <Skeleton class="w-[85px] h-[13px]" />
    </Table.Cell>
  </Table.Row>
</template>

<script setup lang="ts">
import { Table, Skeleton } from '@dacr/ui'
import { useDevice } from '@/shared/composables/useDevice'
import { computed } from 'vue'

const device = useDevice()

const skeletonCount = computed(() =>
  device.isMobile.value || device.isTabletVertical.value ? 4 : 7
)
</script>
